// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subject-image-wrapper {\n  margin-top: 20px;\n}\n.subject-image-wrapper .image-placeholder {\n  background: whitesmoke;\n  border-radius: 20px;\n  max-width: 230px;\n  width: 100%;\n  height: 100%;\n  max-height: 230px;\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.subject-image-wrapper .image-placeholder i {\n  font-size: 8rem;\n  color: lightgrey;\n  -ms-flex-item-align: center;\n      align-self: center;\n  margin: 0 auto;\n}", ""]);
// Exports
module.exports = exports;
